/**
 * A `failed` trade booked nothing and needs the reader's attention; every other status is
 * either done or on its way. This is a property of the `ExternalTrade` resource, not of
 * one screen — `OperationsTab` (the portfolio blotter) and `TransactionCard` (the
 * investor detail page) both render the same `ExternalTrade.status` field and must agree
 * on which color it carries.
 */
export function tradeStatusBadgeVariant(status: string): "outline" | "destructive" {
  return status === "failed" ? "destructive" : "outline";
}
